import React from "react";
import formatNumber, { convertNumberToWordsInFCFA, formatDateWithTime, getOrderLineWarehouseCode } from "../../utils/functions";
import { APP_NAME } from "../../utils";

export default function InstallmentOrderInvoice({ item, payment, isCopy = true }) {
  return (
    <div className={`${isCopy ? 'invoice-copy second-copy' : 'invoice-copy'} relative`}>
      <div className="flex flex-row justify-between items-start mt-10">
        <div className="">
          <img src="/assets/img/logo.png" height={100} width={100} alt={APP_NAME} />

          <p className="mt-3 font-medium text-sm tracking-widest">
            ASEBAT SARL
          </p>
          <p className="font-medium text-sm">C/1775 C, QUARTIER GBEDJEKOME - OUEDO</p>
          <p className="font-medium text-sm">BP 952  ABOMEY - CALAVI,BENIN</p>
          <p className="font-medium text-sm">IFU 3202434985932 - RCCMRB/ABC/24 B 7993</p>
          <p className="font-medium text-sm">+229 01 61 89 89 00</p>
        </div>
      </div>

      <div className="flex flex-row justify-between items-start mt-2">
        <div>
          <p className="font-medium text-sm">
            <span className="font-semibold">Code et Nom Agent</span> : 00{item?.user?.id} - {item?.user?.name || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Date</span> : {formatDateWithTime(payment?.created_at)}
          </p>
        </div>
      </div>

      <p className="text-right mt-2 font-medium text-xl">
        <span className="font-bold">
          Décharge N°
        </span>
        {item.designation && ` : ${item.designation}_${payment?.payment_sequence}`}
      </p>

      <div className="overflow-x-auto">
        <table className="border-collapse mt-3 w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr className="">
              <th className="p-2 border font-semibold pe-7">Code client</th>
              <th className="p-2 border font-semibold text-start">Client</th>
              <th className="p-2 border font-semibold">IFU</th>
              <th className="p-2 border font-semibold">Téléphone</th>
            </tr>
          </thead>
          <tbody className="">
            <tr>
              <td className="p-2 border font-medium">{item?.customer?.client_code}</td>
              <td className="p-2 border font-medium">{item?.customer?.name}</td>
              <td className="p-2 border font-medium">{item?.customer?.ifu}</td>
              <td className="p-2 border font-medium">{item?.customer?.numero}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="overflow-x-auto">
        <table className="border-collapse w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr className="">
              <th className="p-2 border font-semibold text-sm">
                Magasin
              </th>
              <th className="p-2 border font-semibold text-sm">
                Produit
              </th>
              <th className="p-2 border font-semibold text-sm">
                Prix Unitaire
              </th>
              <th className="p-2 border font-semibold text-sm pe-7">
                Quantité
              </th>
              <th className="p-2 border font-semibold text-sm">
                Prix Total
              </th>
            </tr>
          </thead>
          <tbody className="">
            {item?.variants?.length > 0 ? (
              item.variants.map((item, index) => (
                <tr key={index}>
                  <td className="p-2 border font-medium text-sm">
                    {getOrderLineWarehouseCode(item)}
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {item.variant.sku} - {item.variant.name} - {item.variant.product.format} ({item.variant.is_taxable ? 'B' : 'A'})
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {formatNumber(item.modified_unit_selling_price)} FCFA
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {item.quantity}{' '}
                    {item?.variant?.product?.unit?.name === 'Mettre carré'
                      ? 'm²'
                      : item?.variant?.product?.unit?.name === 'Pièce'
                        ? 'pc'
                        : item?.variant?.product?.unit?.name || ''}
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {formatNumber(item.modified_unit_selling_price * item.quantity)} FCFA
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="p-2 font-medium text-center text-sm">
                  Aucun produit dans le panier.
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={4} className="p-2 border font-semibold text-sm">
                Commentaires
              </td>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>Total :</b> {formatNumber(item.montant_net)} FCFA
              </td>
            </tr>
            <tr>
              <td
                colSpan={4}
                rowSpan={4}
                className="border-e-0 p-2 border font-medium text-sm"
              >
                Les marchandises vendues ne sont ni reprises ni échangées. <br />La disponibilité de votre achat n'est plus garantie 14 jours <br />après la date de facturation.
              </td>
              <td className="p-2 border font-semibold text-end text-sm">
                <b>Montant HT :</b> {formatNumber(item.montant_ht)} FCFA
              </td>
            </tr>
            {item.tva > 0 &&
              <tr>
                <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                  {/* Montant de la TVA en espèces */}
                  <b>T.V.A (18%) :</b> {formatNumber(item.tva)} FCFA
                </td>
              </tr>
            }
            {item.aib_value &&
              <tr>
                <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                  {/* Montant de la TVA en espèces */}
                  <b>AIB (0{`${(item.aib_value === 'A' ? 1 : item.aib_value === 'B' ? 5 : '')}`}%) :</b> {formatNumber(item.aib)} FCFA
                </td>
              </tr>
            }
            {item.remise > 0 && (
              <tr>
                <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                  <b>Remise :</b> {formatNumber(item.remise)} FCFA
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                {/* Montant TTC (NET) */}
                <b>NET :</b> {formatNumber(item.montant_net)} FCFA
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="overflow-x-auto">
        <table className="border-collapse w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr>
              <th className="p-2 border font-semibold text-start">Montant payé</th>
              <th className="p-2 border font-semibold text-start">Total déjà payé</th>
              <th className="p-2 border font-semibold text-start">Reste à payer</th>
              <th className="p-2 border font-semibold text-start">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2 border font-medium">{formatNumber(payment.amount)} FCFA</td>
              <td className="p-2 border font-medium">{formatNumber(payment.total_paid_after)} FCFA</td>
              <td className="p-2 border font-medium">{formatNumber(payment.remaining_after)} FCFA</td>
              <td className="p-2 border font-medium">
                {new Date(payment.payment_date).toLocaleDateString()}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="flex flex-wrap justify-between items-center gap-6 mt-3">
        <div>
          <p className="font-medium text-sm capitalize">
            <span className="font-bold">Net à payer en lettre</span> : {convertNumberToWordsInFCFA(item?.montant_net)}
          </p>
          <p className="font-medium text-sm capitalize">
            <span className="font-bold">Montant payé en lettre</span> : {convertNumberToWordsInFCFA(payment.amount)}
          </p>
          <p className="font-medium text-sm capitalize">
            <span className="font-bold">Total déjà payé en lettre</span> : {convertNumberToWordsInFCFA(payment.total_paid_after)}
          </p>
          <p className="font-medium text-sm capitalize">
            <span className="font-bold">Reste à payer en lettre</span> : {convertNumberToWordsInFCFA(payment.remaining_after)}
          </p>
          <p className="font-medium text-sm">
            <span className="font-bold">Mode de règlement</span> : {payment?.payment_method || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-bold">Référence de la pièce</span> : {item?.reference_piece || "Non spécifiée"}
          </p>
        </div>
      </div>
    </div>
  );
}